import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { WebConstants } from 'src/app/util/web.constants';
import { ToastrService } from 'ngx-toastr';
import { TokenStorage } from 'src/app/util/token.storage';
import { OrganizationService } from 'src/app/services/organization.service';
import { Lookup } from 'src/app/model/lookup';
import { LookupService } from 'src/app/services/lookup.service';
import { AuthenticationService } from "src/app/services/authentication.service";
import { GeofenceService } from "src/app/services/geofence.service";
import { GeofenceZoneService } from "src/app/services/geofencezone.service";
import { ZoneService } from "src/app/services/zone.service";

@Component({
  selector: "app-geofence-update-dialog",
  templateUrl: "./geofence-update-dialog.component.html",
  styleUrls: ["./geofence-update-dialog.component.scss"]
})
export class GeofenceUpdateDialogComponent implements OnInit {
  public form: any;
  public roleList: Lookup[] = [];
  public adminRole: any;
  public orgId: number;
  public organizationList: Lookup[] = [];
  public isStatus: boolean = true;
  zoneData: any;
  public dropZoneData = [];
  gdata: any;
  selectedZone: any;

  constructor(public dialogRef: MatDialogRef<GeofenceUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public organizationService: OrganizationService,
    public geofenceService: GeofenceService,
    public geofenceZoneService: GeofenceZoneService,
    public tokenStorage: TokenStorage,
    public toastrService: ToastrService,
    public zoneService: ZoneService,
    public authenticationService: AuthenticationService,
    public lookupService: LookupService) {}

  ngOnInit() {
    // this.getAllZone();
    // this.getAllGeofenceZone();
    this.adminRole = this.authenticationService.currentUserValue.role;
    this.orgId = this.authenticationService.currentUserValue.organizationId;
    this.initlizeGeofenceUpdateForm();
  }

  initlizeGeofenceUpdateForm(): void {
    this.form = new FormGroup({
      geofenceName: new FormControl("", Validators.required),
      geofenceDesc: new FormControl("", Validators.required),
      // zone : new FormControl(this.dropZoneData, Validators.required),
      status: new FormControl(this.isStatus, Validators.required)
    });

    if(this.data.status == 1){
      this.isStatus = true;
    }
    else{
      this.isStatus = false;
    }

    // this.form.get('geofenceId').setValue(this.data.geofenceId);
    // this.form.get('zone').setValue(this.dropZoneData);
    this.form.get('geofenceName').setValue(this.data.geofenceName);
    this.form.get('geofenceDesc').setValue(this.data.geofenceDesc);
    this.form.get('status').setValue(this.isStatus);
  }

  getAllGeofenceZone(): void {
    this.geofenceZoneService.getAll()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.gdata = response.data.filter(x=>x.geofenceId == this.data.geofenceId);
          this.gdata.forEach(element =>{
            this.dropZoneData.push(element.zoneId);
          });
        } else {
          console.log("Zone API Error!");
        }
      });
  }

  getAllZone(): void {
    this.zoneService.getAll()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.zoneData = response.data;
        } else {
          console.log("Zone API Error!");
        }
      });
  }

  updateGeofenceData(): void {
    let data = this.form.getRawValue();
    data.geofenceId = this.data.geofenceId
    // this.selectedZone = data.zone;
    // delete data.zone;
    //data.organizationId = this.tokenStorage.getOrganizationId();
    data.status = this.isStatus ? 1 : 3;

    this.geofenceService.updateGeofence(data)
    .pipe(first())
    .subscribe(response => {
      if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
        // this.deleteGeofenceZoneByGeofenceId(data.geofenceId);
        this.toastrService.success(response.value, "Geofence Updated Successfully!");
        this.dialogRef.close(true);
      } else {
        this.toastrService.error(response.value, "Failed To Load Data!")
      }
    });
  }

  updateGeoFenceZone(){
    this.selectedZone.forEach((zoneid) => {
      let payload = {
        // id: this.gdata.filter(x=>x.zoneId = zoneid)[index].id,
        geofenceId: this.data.geofenceId,
        zoneId: zoneid,
        organizationId: this.orgId,
        status: 1
      }
      this.addGeofenceZoneData(payload);
    });
  }

  addGeofenceZoneData(data): void{
    this.geofenceZoneService.addGeofenceZone(data)
    .pipe(first())
    .subscribe(response => {
      if(response && response.code === WebConstants.STATUS.CODE_SUCCESS){
        // console.log(response.data);
      }
    })
  }

  deleteGeofenceZoneByGeofenceId(data): void{
    this.geofenceZoneService.deleteGeofenceZoneByGeofenceId(data)
    .pipe(first())
    .subscribe(response => {
      if(response && response.code === WebConstants.STATUS.CODE_SUCCESS){
        this.updateGeoFenceZone();
      }
    })
  }

  closeDialog(): void {
    this.dialogRef.close(false);
  }
}